import React from 'react'

const UploadSecondaryImageModal  = () => {
  return (
   <>
   <div class="modal fade" id="uploadSecondaryImageModal" tabindex="-1" role="dialog"
                    aria-labelledby="uploadSecondaryImageModalTitle" aria-hidden="true">
                    <div class="modal-dialog modal-dialog-centered modal-md" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <h5 class="modal-title" id="exampleModalLongTitle">Upload Secondary Images</h5>
                            </div>
                            <div class="modal-body">
                                <div class="row">
                                    <div class="col-md-12">
                                        {/* <nav class="nav nav-pills nav-justified">
              <a class="nav-item nav-link upload-btn" (click)="chooseImgCheck = true"
                [ngClass]="{ 'active':chooseImgCheck == true}"><i class="fas fa-cloud-upload-alt"></i>Upload</a>
              <a class="nav-item nav-link library-btn" (click)="chooseImgCheck = false"
                [ngClass]="{ 'active':chooseImgCheck == false}"><i class="far fa-copy"></i>Library</a>
            </nav>
            <div [hidden]="!chooseImgCheck">
              <form id="file-upload-form" class="pro-image-uploader mt-3">
                <input #productFileUpload id="file-upload-productImg" type="file" name="fileUpload" accept="image/*"
                  (change)="fileSave($event, 'productImg')" />
                <label for="file-upload-productImg" id="file-drag">
                  <div *ngIf="imageFormControl.url.value">
                    <img id="file-image" [src]="imageFormControl.url.value">
                  </div>
                  <div id="start" *ngIf="!imageFormControl.url.value">
                    <span><i class="far fa-image product-capt-color"></i></span>
                    <div class="product-capt-color">Drag your image here or browse</div>
                  </div>
                  <div class="change-img-instruction">
                    <p>To change image click here</p>
                  </div>
                </label>
              
            </div> */}
                                        <div>
                                            <div class="row bg-grey-box mt-3">
                                                <div class="col-md-12">
                                                    <div class="row">
                                                        <div class="col-md-12"  >
                                                            <div class="input-group text-align"  >
                                                                <input type="text" class="form-control lit-grey-color border-none"
                                                                    placeholder="Search a product code" />
                                                                <div class="input-group-append">
                                                                    <button class="btn btn-secondary lit-grey-color" type="button" >
                                                                        <i class="fa fa-search" ></i>
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row mt-3">
                                                        <div class="col-md-3 mb-3">
                                                            <div class="library-images">
                                                                <img src="related_image.imageUrl"
                                                                    alt="" />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="row">
                                                        <div class="no-image-found">
                                                            <i class="far fa-images"></i>
                                                            <p>No image found</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>



                                            <div class="row mt-3 mob-p-l-r">
                                                <div class="col-md-3">
                                                    <div class="product-image mob-p-b-10">
                                                        <img src="related_image.imageUrl" alt="" height="46" />
                                                    </div>
                                                </div>
                                            </div>


                                            <div class="col-md-12">
                                                <div class="row bg-grey-box">
                                                    <div class="col-md-4">
                                                        <div class="library-images">
                                                            <img src="related_image.imageUrl" alt=""
                                                                height="46" />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="float-right mt-3">
                                            <button type="button" class="btn btn-link cancel-btn" data-dismiss="modal">Cancel</button>
                                            <button type="button" class="btn btn-primary black-color-bg"
                                                data-dismiss="modal">Save
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
   </>
  )
}

export default UploadSecondaryImageModal 